import AlchemyApi from './Alchemy';
import Web3 from 'web3';
import factoryAbi from '../abi/StakingFactory.json';
import poolAbi from '../abi/StakingPool.json';
import { EthToConverter } from '../utils';
import { telegramForm } from '@/lib/error-bot/telegram';
import BigNumber from 'bignumber.js';
import { MULTIPLIE_PERCENT } from '@/lib/common/name-space';
export class AdminWeb3 {
  private stakingPool: Record<string, any>;
  private stakingFactory: Record<string, any>;
  private alchemy: AlchemyApi;
  private web3: Web3;
  constructor() {
    this.alchemy = new AlchemyApi();
    this.stakingFactory = {};
    this.stakingPool = {};
    // const provider =
    //   process.env.NODE_ENV === 'product'
    //     ? 'https://polygon-mainnet.g.alchemy.com/v2/demo'
    //     : 'https://polygon-amoy.g.alchemy.com/v2';
    // this.web3 = new Web3(new Web3.providers.HttpProvider(`${provider}/${process.env.ALCHEMY_API_KEY}`));
    // if (this.alchemy !== undefined) {
    //   return;
    // }
    const provider = this.alchemy.getProvider() ?? 'https://polygon-amoy.blockpi.network/v1/rpc/public';
    this.web3 = new Web3(new Web3.providers.HttpProvider(provider));
  }
  setStakingFactory(aData: string[]) {
    aData.forEach((item) => {
      const contract_addr = item.toLocaleLowerCase();
      this.stakingFactory[contract_addr] = new this.web3.eth.Contract(factoryAbi, contract_addr);
    });
  }
  setStakingPool(aContractAddr: string) {
    const contract_addr = aContractAddr.toLocaleLowerCase();
    this.stakingPool[contract_addr] = new this.web3.eth.Contract(poolAbi, contract_addr);
  }

  // ※ 객체 생성, web3js가 해당 계정을 쉽게 참조할 수 있게 선언
  addPrivateKeyWeb3(aPrivateKey: string) {
    const account = this.web3.eth.accounts.privateKeyToAccount(aPrivateKey);
    this.web3.eth.accounts.wallet.add(account);
  }

  // 잔액 업데이트
  async updateTokenMultipliedPrice(aContractAddr: string, aPrice: string, aPrivateKey: string) {
    const contract_addr = aContractAddr.toLocaleLowerCase();
    const contract = this.stakingPool[contract_addr];
    try {
      const account = this.web3.eth.accounts.privateKeyToAccount(`0x${aPrivateKey}`);
      const price = EthToConverter(aPrice, 'szabo');
      const gas = await this.gasPrice();
      const data = contract.methods.updateTokenMultipliedPrice(price).encodeABI();
      const tx = {
        from: account.address,
        to: aContractAddr,
        gasPrice: String(gas),
        data,
      };
      const signedTx = await this.web3.eth.accounts.signTransaction(tx, aPrivateKey);
      const receipt = await this.web3.eth.sendSignedTransaction(signedTx.rawTransaction);
      console.log('Transaction hash:', receipt.transactionHash);
      return { code: 200, data: receipt };
    } catch (e) {
      console.log(`eeeeeeeeeeeeeeeeeeeeeeeeeeeee`);
      console.error(e);
      const text = `"type": "user", "call": "adminWeb3.ts", "method": "updateTokenMultipliedPrice(), "req": "{
      "aContractAddr": ${aContractAddr}, "aPrice": "${aPrice}", aPrivateKey: string}", "msg": "${e}", `;
      telegramForm(text);
      return { code: 400, data: e };
    }
  }
  async gasPrice() {
    const gasPrice = await this.web3.eth.getGasPrice();
    console.log(`gasPrice: ${gasPrice}`);
    const increaseGasPrice = BigNumber(String(gasPrice)).multipliedBy(MULTIPLIE_PERCENT).toFixed(0);
    console.log(`increaseGasPrice: ${increaseGasPrice}`);
    return increaseGasPrice;
  }
}
